import React, {  Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const Home = lazy(() => import("./home"))
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./service/Services"));
const EngineeringProject = lazy(() => import("./service/ServiceDetails/engineering-project"));
const ITProjects = lazy(() => import("./service/ServiceDetails/it-projects-and-automated-infrastructure"));
const TrainingProgramme = lazy(() => import("./service/ServiceDetails/training-programme"));
const ProcurementService = lazy(() => import("./service/ServiceDetails/procurement-service"));
const ElectricalElectronics = lazy(() => import("./service/ServiceDetails/electrical-and-electronics-component"));
const ConstructionWork = lazy(() => import("./service/ServiceDetails/construction-work"));

const Contact = lazy(() => import("./pages/Contact"));
const NoMAtch = lazy(() => import("./pages/404"));

const App = () => {
  return (
    <Router>
        <Suspense fallback={<div />}>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about-us" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/engineering-projects" element={<EngineeringProject />} />
                <Route path="/services/it-projects-and-automated-infrastructure" element={<ITProjects />} />
                <Route path="/services/training-programmes" element={<TrainingProgramme />} />
                <Route path="/services/procurement-services" element={<ProcurementService />} />
                <Route path="/services/electrical-and-electronics-components" element={<ElectricalElectronics />} />
                <Route path="/services/construction-works" element={<ConstructionWork />} />
                <Route path="/contact-us" element={<Contact />} />
                <Route path="*" element={<NoMAtch />} />
            </Routes>
        </Suspense>
      </Router>
  )
}

export default App